<template>
  <div class="box">
    <div id="app-home">
      <div class="icon">
        <img
          @click="handleCheckDetail"
          class="img1"
          :src="imgUrl + list.iconId"
          alt=""
        />
        <!-- <img
          class="img1"
          src="../../../assets/newMedal/time/time4.png"
          alt=""
        /> -->
      </div>

      <img class="img2" :src="list.receivericon" alt="" />
      <div class="message">
        <div class="name">亲爱的{{ list.receivername }}</div>
        <div class="content" v-if="list.remarks">
          <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 恭喜您获得“{{list.medalName}}”勋章！ -->
          <span v-html="list.remarks"></span>
        </div>
        <div class="content" v-else>恭喜您获得{{ list.medalName }}</div>
      </div>
      <div class="footer" @click="handleCheckDetail">查看累计时长</div>
    </div>
  </div>
</template>

<script>
//   import moment from "moment";
//   import apiLogin from "@/apis";
import { getToken } from "@/utils/cookie";
import api from "@/apis/medal";
import apiLogin from "@/apis";
export default {
  name: "medalDetail",
  components: {},
  data() {
    return {
      id: "",
      list: {},
      imgUrl: "",
      empno: ""
    };
  },
  created() {},
  mounted() {
    this.imgUrl = api.imgUrl;
    this.id = this.$route.query.id;
    let token = window.sessionStorage.empNo;
    let hrToken = getToken();
    //获取token
    if (token) {
      this.empno = hrToken;
      this.getList(token);
    } else {
      this.$bus.$on("processToken", res => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.empno = res;
          this.getList(res);
        });
      });
    }
  },
  beforeDestroy() {
    sessionStorage.setItem("isShowBadge", true);
  },
  methods: {
    //获取hrToken&用户信息
    getHrToken(username) {
      return new Promise(resolve => {
        if (username) {
          let thisname = username;

          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then(data => {
            const info = data.data;

            localStorage.setItem("salaryPhone", info.mobileNo);
            localStorage.setItem("salaryInfo", JSON.stringify(info));

            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    //获取勋章详情
    getList(token) {
      api
        .medalCardDetailApi({
          id: this.id,
          empno: token,
          channel: this.$route.query.value
        })
        .then(res => {
          if (res.code == 200) {
            const checkList =
              res.data.receiverEmpno +
              "," +
              res.data.senderEmpno +
              "," +
              res.data.ccEmpno;
            if (checkList.includes(token)) {
              this.list = res.data;
              this.list.ccers = res.data.ccers.join(";");
            } else {
              this.$router.push({
                path: "/mobile/medal"
              });
            }
          }
        })
        .catch(err => {
          if (err.code === 0) {
            this.$message({
              type: "error", // success error warning
              message: err.message,
              duration: 2000
            });
          }
        });
    },
    //跳转公益
    handleCheckDetail() {
      localStorage.setItem("publicWelfareActive", 1);
      this.$router.push({
        path: "/mobile/medal/publicWelfare"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  #app-home {
    width: 100%;
    // background: rgba(244, 245, 248, 1);
    background: #f7f9fa;
    min-height: 100vh;
    overflow: hidden;
    background: url("~@/assets/newMedal/bg17.png");
    background-size: 100% 100%;
    position: absolute;
  }
}

@media screen and (min-width: 600px) {
  #app-home {
    width: 276px * $zoom;
    // background: rgba(244, 245, 248, 1);
    background: #f7f9fa;
    min-height: 100vh;
    overflow: hidden;
    background: url("~@/assets/newMedal/bg17.png");
    background-size: 100% 100%;
    position: absolute;
  }
}

.box {
  width: 100%;
  display: flex;
  justify-content: center;
}
.top {
  position: absolute;
  top: 5%;
  left: 0%;
  right: 0;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 54px;
  font-weight: 600;
  background: linear-gradient(
    180deg,
    rgba(255, 243, 223, 1) 0,
    rgba(198, 147, 90, 1) 99.95083%
  );
  color: transparent;
  letter-spacing: 4px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.icon {
  position: absolute;
  top: 3%;
  left: 0%;
  width: 100%;
  display: flex;
  justify-content: center;
  .img1 {
    // width: 280px;
    height: 21vh;
  }
}
.check_con {
  font-family: PingFangSC, PingFang SC;
  position: absolute;
  top: 31vh;
  left: 0%;
  width: 100%;
  background: linear-gradient(180deg, #fff3df 0%, #c6935a 100%);
  font-weight: bold;
  color: transparent;
  letter-spacing: 4px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  font-size: 30px;
}
.img2 {
  width: 95px;
  height: 95px;
  position: absolute;
  top: 26%;
  // left: 19%;
  left: 0;
  right: 0;
  margin: 0 auto;
  border-radius: 50%;
  border: 4px solid #fff;
}
.message {
  position: absolute;
  top: 36%;
  left: 14%;
  right: 10%;
  .name {
    font-size: 34px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #8d4e4e;
  }
  .content {
    width: 100%;
    font-size: 28px;
    font-weight: 400;
    line-height: 50px;
    height: 23vh;
    overflow-y: auto;
    color: #8d4e4e;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
.footer {
  width: 100%;
  height: 7%;
  position: absolute;
  bottom: 40px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 30px;
  color: #8d4e4e;
  font-size: 30px;
}
</style>
